const companiesStrings = {
  companiesHeader: {
    addCompanyBtn: 'Add Company',
  },

  companiesFilter: {
    searchBarPlaceholder: 'Company Name or Email',
  },

  companiesList: {
    companiesGridNoResultsFound: 'No results matching your search criteria',
    companiesListLabels: {
      companyTitleLabel: 'Company',
      companyNameLabel: 'Name',
      companyEmailLabel: 'Email',
    },
  },

  addCompany: {
    formTitle: 'Company Details',
    formNameFieldLabel: 'Name',
    formDescriptionFieldLabel: 'Description',
    formLongDescriptionFieldLabel: 'Long Description',
    formEmailFieldLabel: 'Email',
    formWebsiteFieldLabel: 'Website',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    formAddBtnText: 'Add',
    requestErrorMessage: 'Error happened, please try again',
  },
};

export default companiesStrings;
